import React, { FC } from 'react';
import DashboardCards from '../atoms/DashboardCards';

import { useNavigate } from 'react-router-dom';

interface Props {
  id: number;
  title: string;
  description: string;
  phase?:number
}

interface DashboardListProps {
  tiles: Props[];
  onDelete: (id: number) => void;
  loading: boolean;
  category: string;
}
// Define the DashboardList component
const DashboardList: FC<DashboardListProps> = ({ tiles, category,onDelete }) => {
  const navigate = useNavigate();
  const data = category.replace('-',' ')
  const isAiSpace = category === "knowledge-hubs";
  const isAiCrew = category === "crews";

  const handleClick = (id:number) => {
    if (isAiSpace) {
      navigate(`/space/${id}`);
    } else if (isAiCrew) {
      navigate(`/edit_crew/${id}`);
    }
  };
  return (
    <div>
      {tiles.length > 0 ? (
        <div className="All_crews_space_tils mb-3">
          {tiles.slice(0, 3).map((tile) => (
            <div  style={{ cursor: "pointer" }} onClick={()=>handleClick(tile.id)} key={tile.id} className={category === 'crews'? `assigned_tiles_crews d-flex flex-column h-100 p-3 pt-2`:`assigned_tiles_space d-flex flex-column h-100 p-3 pt-2`}>
              <DashboardCards
                id={tile?.id}
                 title={tile?.title}
                 phase={tile?.phase }
                description={tile?.description}
                category={category}
                onDelete={onDelete}
              />
            </div>
          ))}
        </div>
      ) :  (
        <div className="col-12 text-center">
 
          <p>{`No ${data} are available`}</p>
        </div>
      )}
    </div>
  );
};

export default DashboardList;


